export const SERVER_ENDPOINT = 'https://api.ultravipbd.pro';
export const BASE_API = `${SERVER_ENDPOINT}`;

export const AUTH_BASE_URL = 'https://api.ultravipbd.pro';
export const BI_BASE_URL = 'https://api.ultravipbd.pro/bi/api/v1';
export const PANEl_BASE_URL = 'https://panel.ultravipbd.pro/api/v2';
